import { render, staticRenderFns } from "./CustomerSearchBox.vue?vue&type=template&id=64f620e8&"
import script from "./CustomerSearchBox.vue?vue&type=script&lang=js&"
export * from "./CustomerSearchBox.vue?vue&type=script&lang=js&"
import style0 from "./CustomerSearchBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports